
//let UrlApi = 'http://dev.tae-col.com/';
// let UrlApi = localStorage.getItem('AmbienteTae_Url'); //'https://localhost:7066/';

// const urlApiTae = localStorage.getItem("AmbienteTae_Url");

// Api Local
// const urlApiTae = "https://localhost:7066/";

const urlApiProduccion =  window.APP_CONFIG.API_URL;

async function getData(action = "", params = {}, PrintUrl = false) {
  // let UrlBase = `${urlApiTae}${action}?`;
  let UrlBase = localStorage.getItem('AmbienteTae_Url') + '' + action + '?';

  console.log(":::: URL BASE", UrlBase);
  Object.keys(params).forEach((key) => {
    let valor = encodeURIComponent(String(params[key]));

    UrlBase = UrlBase + key + "=" + valor + "&";
  });

  if (PrintUrl === true) {
    console.log(UrlBase);
  }

  ///Pendiente asignar token aqui
  const token = localStorage.getItem('tokenSesion');

  return await fetch(UrlBase, {
    method: 'GET',
    headers: {
      'Authorization': 'Bearer ' + token,
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  }).then(response => response.json())
    .then(data => data)
    .catch(error => {
      alert('Algo salio mal en la peticion');
      console.log(error);
      return error;
    });

}

async function getFileData(action = '', params = {}, PrintUrl = false) {

  let UrlBase = localStorage.getItem('AmbienteTae_Url') + '' + action + '?';

  Object.keys(params).forEach(key => {
    let valor = encodeURIComponent(String(params[key]));

    UrlBase = UrlBase + key + '=' + valor + '&';
  });

  if (PrintUrl === true) {
    console.log(UrlBase);
  }

  ///Pendiente asignar token aqui
  const token = localStorage.getItem('tokenSesion');

  return await fetch(UrlBase, {
    method: 'GET',
    headers: {
      'Authorization': 'Bearer ' + token,
      'Accept': 'application/json',
      'Content-Type': 'application/octet-stream'
    }
  }).then(response => response.blob())
    .then(data => data)
    .catch(error => {
      alert('Algo salio mal en la peticion');
      console.log(error);
      return error;
    });

}

async function postData(action = '', params = {}, data = {}, PrintUrl = false) {

  let UrlBase = localStorage.getItem('AmbienteTae_Url') + '' + action + '?';

  // let UrlBase = `${urlApiTae}${action}?`;


  Object.keys(params).forEach(key => {
    let valor = encodeURIComponent(String(params[key]));

    UrlBase = UrlBase + key + '=' + valor + '&';
  });

  if (PrintUrl === true) {
    console.log(UrlBase);
  }

  ///Pendiente asignar token aqui
  const token = localStorage.getItem('tokenSesion');

  return await fetch(UrlBase, {
    method: 'POST',
    headers: {
      'Authorization': 'Bearer ' + token,
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  }).then(response => response.json())
    .then(data => data)
    .catch(error => {
      alert('Algo salio mal en la peticion');
      console.log(error);
      return error;
    });

}

async function patchData(
  action = "",
  params = {},
  data = {},
  PrintUrl = false
) {

  // let UrlBase = `${urlApiTae}${action}?`;
  let UrlBase = localStorage.getItem("AmbienteTae_Url") + "" + action + "?";

  Object.keys(params).forEach((key) => {
    let valor = encodeURIComponent(String(params[key]));

    UrlBase = UrlBase + key + "=" + valor + "&";
  });

  if (PrintUrl === true) {
    console.log(UrlBase);
  }

  ///Pendiente asignar token aqui
  const token = localStorage.getItem("tokenSesion");

  return await fetch(UrlBase, {
    method: "PATCH",
    headers: {
      Authorization: "Bearer " + token,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => data)
    .catch((error) => {
      alert("Algo salio mal en la peticion");
      console.log(error);
      return error;
    });
}

async function putData(
  action = "",
  params = {},
  data = {},
  PrintUrl = false
) {

  // let UrlBase = `${urlApiTae}${action}?`;
  let UrlBase = localStorage.getItem("AmbienteTae_Url") + "" + action + "?";

  Object.keys(params).forEach((key) => {
    let valor = encodeURIComponent(String(params[key]));

    UrlBase = UrlBase + key + "=" + valor + "&";
  });

  if (PrintUrl === true) {
    console.log(UrlBase);
  }

  ///Pendiente asignar token aqui
  const token = localStorage.getItem("tokenSesion");

  return await fetch(UrlBase, {
    method: "PUT",
    headers: {
      Authorization: "Bearer " + token,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => data)
    .catch((error) => {
      alert("Algo salio mal en la peticion");
      console.log(error);
      return error;
    });
}



export { getData, getFileData, postData, patchData, putData, urlApiProduccion }

